export default __webpack_public_path__ + "static/media/icon_linkedin.68246d82.webp";